"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { AuthContext } from "@/components/auth/Auth";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiProfileRepRatesState, RatingStats } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
export function useRepAllocation(t0) {
  const $ = _c(76);
  const {
    profile,
    category
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const t1 = activeProfileProxy?.created_by.handle;
  const t2 = profile?.handle;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [QueryKey.PROFILE_REP_RATINGS, {
      rater: t1,
      handleOrWallet: t2
    }];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeProfileProxy || $[4] !== profile?.query) {
    t4 = async () => await commonApiFetch({
      endpoint: `profiles/${profile?.query}/rep/ratings/received`,
      params: activeProfileProxy?.created_by.handle ? {
        rater: activeProfileProxy.created_by.handle
      } : {}
    });
    $[3] = activeProfileProxy;
    $[4] = profile?.query;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !!activeProfileProxy?.created_by.handle;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data: proxyGrantorRepRates
  } = useQuery(t6);
  const t7 = connectedProfile?.handle;
  const t8 = profile?.handle;
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = [QueryKey.PROFILE_REP_RATINGS, {
      rater: t7,
      handleOrWallet: t8
    }];
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== connectedProfile || $[14] !== profile?.query) {
    t10 = async () => await commonApiFetch({
      endpoint: `profiles/${profile?.query}/rep/ratings/received`,
      params: connectedProfile?.handle ? {
        rater: connectedProfile.handle
      } : {}
    });
    $[13] = connectedProfile;
    $[14] = profile?.query;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = !!connectedProfile?.handle;
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
    t12 = {
      queryKey: t9,
      queryFn: t10,
      enabled: t11
    };
    $[16] = t10;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const {
    data: connectedProfileRepRates
  } = useQuery(t12);
  let t13;
  if ($[20] !== activeProfileProxy || $[21] !== category || $[22] !== connectedProfileRepRates || $[23] !== proxyGrantorRepRates) {
    t13 = () => {
      if (!category) {
        return null;
      }
      if (activeProfileProxy && proxyGrantorRepRates) {
        const target = proxyGrantorRepRates.rating_stats.find(s => s.category === category);
        return target ?? {
          category,
          rating: 0,
          contributor_count: 0,
          rater_contribution: 0
        };
      }
      if (activeProfileProxy) {
        return null;
      }
      if (connectedProfileRepRates) {
        const target_0 = connectedProfileRepRates.rating_stats.find(s_0 => s_0.category === category);
        return target_0 ?? {
          category,
          rating: 0,
          contributor_count: 0,
          rater_contribution: 0
        };
      }
      return null;
    };
    $[20] = activeProfileProxy;
    $[21] = category;
    $[22] = connectedProfileRepRates;
    $[23] = proxyGrantorRepRates;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const getRepState = t13;
  let t14;
  if ($[25] !== activeProfileProxy?.actions) {
    t14 = () => {
      const repProxy = activeProfileProxy?.actions.find(_temp);
      if (!repProxy) {
        return null;
      }
      return Math.max((repProxy.credit_amount ?? 0) - (repProxy.credit_spent ?? 0), 0);
    };
    $[25] = activeProfileProxy?.actions;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const getProxyAvailableCredit = t14;
  let t15;
  if ($[27] !== activeProfileProxy || $[28] !== connectedProfileRepRates?.rep_rates_left_for_rater || $[29] !== proxyGrantorRepRates?.rep_rates_left_for_rater) {
    t15 = () => {
      if (activeProfileProxy) {
        return proxyGrantorRepRates?.rep_rates_left_for_rater ?? 0;
      }
      return connectedProfileRepRates?.rep_rates_left_for_rater ?? 0;
    };
    $[27] = activeProfileProxy;
    $[28] = connectedProfileRepRates?.rep_rates_left_for_rater;
    $[29] = proxyGrantorRepRates?.rep_rates_left_for_rater;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const getHeroAvailableRep = t15;
  let t16;
  if ($[31] !== getRepState) {
    t16 = getRepState();
    $[31] = getRepState;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const [repState, setRepState] = useState(t16);
  const [proxyAvailableCredit, setProxyAvailableCredit] = useState(getProxyAvailableCredit());
  let t17;
  if ($[33] !== getHeroAvailableRep) {
    t17 = getHeroAvailableRep();
    $[33] = getHeroAvailableRep;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const [heroAvailableRep, setHeroAvailableRep] = useState(t17);
  let t18;
  if ($[35] !== getRepState) {
    t18 = () => {
      setRepState(getRepState());
    };
    $[35] = getRepState;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== activeProfileProxy || $[38] !== category || $[39] !== connectedProfileRepRates || $[40] !== proxyGrantorRepRates) {
    t19 = [category, proxyGrantorRepRates, activeProfileProxy, connectedProfileRepRates];
    $[37] = activeProfileProxy;
    $[38] = category;
    $[39] = connectedProfileRepRates;
    $[40] = proxyGrantorRepRates;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  useEffect(t18, t19);
  let t20;
  if ($[42] !== getProxyAvailableCredit) {
    t20 = () => setProxyAvailableCredit(getProxyAvailableCredit());
    $[42] = getProxyAvailableCredit;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== activeProfileProxy) {
    t21 = [activeProfileProxy];
    $[44] = activeProfileProxy;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  useEffect(t20, t21);
  let t22;
  if ($[46] !== getHeroAvailableRep) {
    t22 = () => setHeroAvailableRep(getHeroAvailableRep());
    $[46] = getHeroAvailableRep;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== activeProfileProxy || $[49] !== connectedProfileRepRates || $[50] !== proxyGrantorRepRates) {
    t23 = [activeProfileProxy, proxyGrantorRepRates, connectedProfileRepRates];
    $[48] = activeProfileProxy;
    $[49] = connectedProfileRepRates;
    $[50] = proxyGrantorRepRates;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  useEffect(t22, t23);
  let t24;
  if ($[52] !== heroAvailableRep || $[53] !== proxyAvailableCredit || $[54] !== repState?.rater_contribution) {
    t24 = () => {
      const currentRep = repState?.rater_contribution ?? 0;
      const minHeroRep = 0 - (Math.abs(currentRep) + heroAvailableRep);
      if (typeof proxyAvailableCredit !== "number") {
        return minHeroRep;
      }
      const minProxyRep = currentRep - proxyAvailableCredit;
      return Math.abs(minHeroRep) < Math.abs(minProxyRep) ? minHeroRep : minProxyRep;
    };
    $[52] = heroAvailableRep;
    $[53] = proxyAvailableCredit;
    $[54] = repState?.rater_contribution;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const getMinValue = t24;
  let t25;
  if ($[56] !== heroAvailableRep || $[57] !== proxyAvailableCredit || $[58] !== repState?.rater_contribution) {
    t25 = () => {
      const currentRep_0 = repState?.rater_contribution ?? 0;
      const maxHeroRep = Math.abs(currentRep_0) + heroAvailableRep;
      if (typeof proxyAvailableCredit !== "number") {
        return maxHeroRep;
      }
      const maxProxyRep = currentRep_0 + proxyAvailableCredit;
      return Math.min(maxHeroRep, maxProxyRep);
    };
    $[56] = heroAvailableRep;
    $[57] = proxyAvailableCredit;
    $[58] = repState?.rater_contribution;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  const getMaxValue = t25;
  const t26 = getMinValue();
  const t27 = getMaxValue();
  let t28;
  if ($[60] !== t26 || $[61] !== t27) {
    t28 = {
      min: t26,
      max: t27
    };
    $[60] = t26;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  const [minMaxValues, setMinMaxValues] = useState(t28);
  let t29;
  if ($[63] !== getMaxValue || $[64] !== getMinValue) {
    t29 = () => setMinMaxValues({
      min: getMinValue(),
      max: getMaxValue()
    });
    $[63] = getMaxValue;
    $[64] = getMinValue;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== heroAvailableRep || $[67] !== proxyAvailableCredit || $[68] !== proxyGrantorRepRates || $[69] !== repState) {
    t30 = [repState, proxyGrantorRepRates, proxyAvailableCredit, heroAvailableRep];
    $[66] = heroAvailableRep;
    $[67] = proxyAvailableCredit;
    $[68] = proxyGrantorRepRates;
    $[69] = repState;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  useEffect(t29, t30);
  let t31;
  if ($[71] !== heroAvailableRep || $[72] !== minMaxValues || $[73] !== proxyAvailableCredit || $[74] !== repState) {
    t31 = {
      repState,
      heroAvailableRep,
      proxyAvailableCredit,
      minMaxValues
    };
    $[71] = heroAvailableRep;
    $[72] = minMaxValues;
    $[73] = proxyAvailableCredit;
    $[74] = repState;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  return t31;
}
function _temp(a) {
  return a.action_type === ApiProfileProxyActionType.AllocateRep;
}